import { payloadClient } from './index';

/**
 * Parameters for initiating Microsoft OAuth login.
 */
export interface StartMicrosoftLoginParams {
  /** Path to redirect to after successful auth */
  redirectPath?: string;
  /** Login mode: 'gmn' for GMN admin, 'customer' for customer users */
  mode?: 'gmn' | 'customer';
  /** Optional invite token for invite acceptance flow */
  inviteToken?: string;
}

/**
 * Response from the Microsoft auth start endpoint.
 */
export interface StartMicrosoftLoginResponse {
  /** The Microsoft OAuth authorization URL to redirect to */
  authorizationUrl: string;
}

/**
 * Initiates the Microsoft OAuth login flow.
 *
 * Calls the backend to get an authorization URL with proper state,
 * then redirects the browser to Microsoft's login page.
 *
 * @param params - Optional parameters for the login flow
 * @throws Error if the backend request fails
 */
export async function startMicrosoftLogin(params: StartMicrosoftLoginParams = {}): Promise<void> {
  const response = await payloadClient.customRequest<StartMicrosoftLoginResponse>({
    subpath: '/auth/microsoft/start',
    method: 'POST',
    data: {
      redirectPath: params.redirectPath || window.location.pathname,
      mode: params.mode,
      inviteToken: params.inviteToken,
    },
  });

  // Redirect browser to Microsoft login page
  window.location.href = response.authorizationUrl;
}
